// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2wAnv","header":"MergedInvoice_header__r59QB"};